import axios from 'axios';

const hs = {
    Accept: 'application/json',
    'Content-type': 'application/json',
    'Accept-Language': 'es',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0'
};

const AxiosClient = (url: string) => {
    const axiosInstance = axios.create({
        withCredentials: true,
        baseURL: url,
        headers: hs
    });

    // Set the AUTH token for any request
    axiosInstance.interceptors.request.use((config: any) => {
        const newConfig = config;
        const IS_SERVER = typeof window === 'undefined';
        if (!IS_SERVER) {
            const authorization = localStorage.getItem('Authorization');
            newConfig.headers.Authorization = authorization || '';
        }

        return newConfig;
    });

    return axiosInstance;
};

export default AxiosClient;
